module.exports = __webpack_public_path__ + "static/media/security.7f5c6470.png";